/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RoutesRoutes {
  ALTERAR_BENEF_RELATORIO_ROUTE = '/alterar-beneficiario/relatorios',
  ALTERAR_DATA_ADMISSAO_ROUTE = '/alterar-beneficiario/:nrSeqBeneficiario/alterar-admissao',
  ALTERAR_LOCALIZACAO_ROUTE = '/alterar-beneficiario/:nrSeqBeneficiario/alterar-localizacao',
  ALTERAR_MATRICULA_ROUTE = '/alterar-beneficiario/:nrSeqBeneficiario/alterar-matricula',
  ALTERAR_SENHA_ROUTE = '/meus-dados/alterar-senha',
  ALTERAR_VINCULO_ROUTE = '/alterar-beneficiario/:nrSeqBeneficiario/alterar-vinculo',
  ASSIGN_TERMO_USO_ROUTE = '/termo-de-uso/:nrSeqTermo',
  AVISO_PRIVACIDADE_ROUTE = '/aviso-de-privacidade/:nrSeqAviso',
  BENEFICIARIO_DOSSIE_ROUTE = '/dossie-beneficiario',
  BENEFICIARY_CHANGE_ROUTE = '/alterar-beneficiario',
  CONFIRMAR_CARTAO_ROUTE = '/alterar-beneficiario/cartao/:nrSeqBeneficiario/confirmar',
  CONFIRMAR_MIGRACAO_CONTRATO = '/alterar-beneficiario/:nrSeqBeneficiario/migracao-contrato',
  CONSULTAR_ALTERACAO_PRODUTO_ROUTE = '/alteracao-produto',
  CONSULTAR_ALTERACOES_VINCULO_ROUTE = '/alteracoes-vinculo',
  CONSULTAR_CARTAO_ROUTE = '/alterar-beneficiario/cartao/:nrSeqBeneficiario/consultar',
  CONSULTAR_COMPARTILHAMENTO_RISCO_ROUTE = '/compartilhamento-risco',
  CONSULTAR_STATUS_VIA_ROUTE = '/consulta-segunda-via',
  DADOS_PESSOAIS_DETALHES = '/alterar-beneficiario/:nrSeqBeneficiario/pessoa/:cdPessoaFisica/detalhes',
  DASHBOARD_HISTORICO_ALT_CADASTRAL = '/pessoas/:cdPessoaFisica/historico-alteracao-cadastral',
  DASHBOARD_ROUTE = '/',
  DINAMICO_ROUTE = '/dinamico',
  FINALIZAR_REPASSE_ROUTE = '/alterar-beneficiario/:nrSeqBeneficiario/finalizar-repasse',
  LOTE_ROUTE = '/lotes/:nrSeqLote',
  MOVIMENTACAO_DADOS_PESSOAIS = '/alterar-beneficiario/:nrSeqBeneficiario/pessoa/:cdPessoaFisica',
  MOVIMENTACAO_LOTE_ROUTE = '/lotes',
  REDIRECT_MEUS_DADOS = '/meus-dados',
  RELATORIOS_ROUTE = '/relatorios',
  ROUTE_ALTERACAO_LOCALIZACAO = '/alteracao-localizacao',
  ROUTE_ALTERAR_SUBESTIPULANTE = '/alterar-beneficiario/:nrSeqBeneficiario/alterar-subestipulante',
  ROUTE_ANALISE_ATENDIMENTOS = '/analise-atendimentos',
  ROUTE_ANALISE_ATENDIMENTOS_DETALHES_AUTORIZACAO = '/analise-atendimentos/:nrSeqGuia/detalhes-autorizacao',
  ROUTE_ANALISE_ATENDIMENTOS_DETALHES_REQUISICAO = '/analise-atendimentos/:nrSeqAuditoria/detalhes-requisicao',
  ROUTE_BENEF_DETALHES = '/exclusao-beneficiario/:nrSeqRescisao/solicitacao-rescisao/:ieSolicitacaoRescisao',
  ROUTE_BENEF_INCONSISTENCIA_SIB = '/inconsistencia-sib',
  ROUTE_BENEF_REENVIO_SOLICITACAO = '/exclusao-beneficiario/:nrSeqRescisao/solicitacao-rescisao/:ieSolicitacaoRescisao/reenviar-exclusao',
  ROUTE_BENEFICIARY = '/estipulante/:cdPessoaFisica/detalhes/:nrSeqBeneficiario',
  ROUTE_CONSULTA_REINCLUSAO_BENEF = '/reinclusao-beneficiario',
  ROUTE_CONTRATO_DOSSIE = '/contrato-dossie',
  ROUTE_DETALHES_BENEF_LOTE = '/lotes/:nrSeqLote/beneficiarios/:nrSeqInclusao',
  ROUTE_EXCLUSAO_BENEFICIARIO = '/exclusao-beneficiario/nova-exclusao',
  ROUTE_EXCLUSAO_BENEFICIARIO_CONSULTA = '/exclusao-beneficiario',
  ROUTE_FATURAS = '/faturas',
  ROUTE_FOLHAS_PAGAMENTO = '/folhas-pagamento',
  ROUTE_HISTORICO_ATENDIMENTO = '/historico-analises',
  ROUTE_HISTORICO_ATENDIMENTO_DETALHES = '/historico-analises/:nrSeqAuditoria/detalhes',
  ROUTE_HISTORICO_AUTORIZACAO = '/historicos-autorizacoes/:nrSeqGuia',
  ROUTE_HISTORICO_AUTORIZACAO_CONSULTA = '/historicos-autorizacoes',
  ROUTE_HISTORICO_AUTORIZACAO_CONSULTA_FROM_REQUISICAO = '/historicos-requisicoes/:nrSeqRequisicao/autorizacoes/:nrSeqGuia',
  ROUTE_HISTORICO_REQUISICAO = '/historicos-requisicoes/:nrSeqRequisicao',
  ROUTE_HISTORICO_REQUISICAO_CONSULTA = '/historicos-requisicoes',
  ROUTE_HISTORICO_SOLICITACOES = '/historico-solicitacoes',
  ROUTE_INCLUIR_BENEF_LOTE = '/lotes/:nrSeqLote/incluir-beneficiario',
  ROUTE_INCLUSAO_BENEFICIARIO = '/beneficiarios/inclusoes',
  ROUTE_INCLUSAO_BENEFICIARIO_NOVA_INCLUSAO = '/beneficiarios/inclusoes/nova',
  ROUTE_INCLUSAO_BENEFICIARIO_SEQ_DETALHES = '/beneficiarios/inclusoes/:nrSeqInclusao/detalhes',
  ROUTE_INCLUSAO_BENEFICIARIO_SEQ_NOVA_INCLUSAO = '/beneficiarios/inclusoes/:nrSeqInclusao/reenviar',
  ROUTE_MENSAGENS = '/mensagens',
  ROUTE_MENSAGENS_DETALHES = '/mensagens/:nrSeqComunicado/detalhes',
  ROUTE_MENSALIDADES = '/mensalidades',
  ROUTE_PRIVACIDADE = '/privacidade',
  ROUTE_PRODUCT_CHANGE = '/alterar-beneficiario/:nrSeqBeneficiario/alterar-produto',
  ROUTE_REINCLUSAO_BENEF = '/reinclusao-beneficiario/:nrSeqBeneficiario',
  ROUTE_TEST = '/viewer',
  SOLICITAR_CARTAO_ROUTE = '/alterar-beneficiario/cartao/:nrSeqBeneficiario/solicitar',
  SOLICITAR_REPASSE_ROUTE = '/alterar-beneficiario/:nrSeqBeneficiario/solicitar-repasse',
  TRANSFERIR_TITULARIDADE_ROUTE = '/alterar-beneficiario/:nrSeqBeneficiario/transferir-titularidade',
}
export { RoutesRoutes };
